const MediaTypeEnum = Object.freeze({
    MARKETING: 'MARKETING',
    INVESTOR: 'INVESTOR',
    BRANDING: 'BRANDING',
    ADVISER: 'ADVISER'
});

export default MediaTypeEnum;
